import type {Guidebook} from '@chekin/core';
import {ChevronRight} from 'lucide-react';
import {cn} from '@chekinapp/ui';
import {GuidebookIcon} from './GuidebookIcon';

type GuidebookRowProps = {
  guidebook: Guidebook;
  onClick: () => void;
  className?: string;
};

export function GuidebookRow({guidebook, onClick, className}: GuidebookRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group relative flex w-full items-center gap-3 px-[14px] py-3 text-left transition-colors hover:bg-[var(--chekin-neutral-50)]',
        'after:absolute after:left-[66px] after:right-[14px] after:top-0 after:h-px after:bg-[var(--chekin-divider-subtle)] after:content-[""] first:after:hidden',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--chekin-color-brand-blue)]',
        className,
      )}
    >
      <span className="flex size-10 shrink-0 items-center justify-center rounded-[12px] bg-[var(--chekin-blue-tint-info)] text-[var(--chekin-color-brand-blue)]">
        <GuidebookIcon
          name={guidebook.icon}
          size={20}
          color="var(--chekin-color-brand-blue)"
        />
      </span>

      <span className="min-w-0 flex-1">
        <span className="block text-[14px] font-semibold leading-5 text-[var(--chekin-color-brand-navy)]">
          {guidebook.title}
        </span>
        {guidebook.description ? (
          <span className="mt-px block text-[13px] leading-[17px] text-[var(--chekin-text-secondary)]">
            {guidebook.description}
          </span>
        ) : null}
      </span>

      <ChevronRight
        size={18}
        className="shrink-0 text-[var(--chekin-neutral-500)] transition-[transform,color] group-hover:translate-x-0.5 group-hover:text-[var(--chekin-color-brand-blue)]"
      />
    </button>
  );
}
